// @ts-nocheck
/*
  mh-mega-menu.js
  Mega menu interactions for the M&H Living header.
  Triggered by [data-mh-mega-trigger], opens on hover and click.
*/

(function () {
  'use strict';

  function initMegaMenu() {
    document.querySelectorAll('[data-mh-mega-trigger]').forEach(function (trigger) {
      if (trigger._mhMegaBound) return;
      trigger._mhMegaBound = true;

      var megaId   = trigger.getAttribute('data-mh-mega-trigger');
      var panel    = document.getElementById('mh-mega-' + megaId);
      var backdrop = document.querySelector('[data-mh-mega-backdrop]');
      var navItem  = trigger.closest('li') || trigger.parentElement;
      if (!panel) return;

      var tabs    = panel.querySelectorAll('[data-mh-mega-tab]');
      var panes   = panel.querySelectorAll('[data-mh-mega-panel]');
      var ctas    = panel.querySelectorAll('[data-mh-mega-cta]');
      var closeTimer = null;

      function activateTab(idx) {
        idx = parseInt(idx, 10);
        tabs.forEach(function (t) {
          t.setAttribute('aria-selected', parseInt(t.dataset.mhMegaTab, 10) === idx ? 'true' : 'false');
        });
        panes.forEach(function (p) {
          var match = parseInt(p.dataset.mhMegaPanel, 10) === idx;
          p.classList.toggle('is-active', match);
          if (match) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); }
        });
        ctas.forEach(function (c) {
          var match = parseInt(c.dataset.mhMegaCta, 10) === idx;
          c.classList.toggle('is-active', match);
          if (match) { c.removeAttribute('hidden'); } else { c.setAttribute('hidden', ''); }
        });
      }

      function open() {
        clearTimeout(closeTimer);
        panel.removeAttribute('hidden');
        if (backdrop) backdrop.removeAttribute('hidden');
        requestAnimationFrame(function () {
          panel.classList.add('is-open');
          if (backdrop) backdrop.classList.add('is-open');
        });
        panel.setAttribute('aria-hidden', 'false');
        trigger.setAttribute('aria-expanded', 'true');
      }

      function close() {
        panel.classList.remove('is-open');
        if (backdrop) backdrop.classList.remove('is-open');
        panel.setAttribute('aria-hidden', 'true');
        trigger.setAttribute('aria-expanded', 'false');
        closeTimer = setTimeout(function () {
          panel.setAttribute('hidden', '');
          if (backdrop) backdrop.setAttribute('hidden', '');
        }, 200);
      }

      function scheduleClose() {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(close, 500);
      }

      function isOpen() {
        return panel.classList.contains('is-open');
      }

      function isHoverCapable() {
        return window.matchMedia('(hover: hover)').matches;
      }

      /* ── Hover opens; mouse-out auto-closes after 2s; click-outside / Escape close instantly ── */
      navItem.addEventListener('mouseenter', function () {
        if (!isHoverCapable()) return;
        open();
      });

      navItem.addEventListener('mouseleave', function () {
        if (!isHoverCapable()) return;
        scheduleClose();
      });

      panel.addEventListener('mouseenter', function () {
        if (!isHoverCapable()) return;
        open();
      });

      panel.addEventListener('mouseleave', function () {
        if (!isHoverCapable()) return;
        scheduleClose();
      });

      /* ── Click toggle (also works as fallback on touch) ── */
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        isOpen() ? close() : open();
      });

      /* ── Keyboard ─────────────────────────────────── */
      trigger.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { close(); return; }
        if ((e.key === 'ArrowDown' || e.key === ' ' || e.key === 'Enter') && !isOpen()) {
          e.preventDefault();
          open();
        }
      });

      /* ── Tabs: click or hover activates ────────────── */
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () { activateTab(tab.dataset.mhMegaTab); });
        tab.addEventListener('mouseenter', function () { activateTab(tab.dataset.mhMegaTab); });
      });

      /* ── Panel keyboard nav ───────────────────────── */
      panel.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { close(); trigger.focus(); return; }
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          var current = Array.from(tabs).findIndex(function (t) {
            return t.getAttribute('aria-selected') === 'true';
          });
          var next = e.key === 'ArrowDown'
            ? Math.min(current + 1, tabs.length - 1)
            : Math.max(current - 1, 0);
          activateTab(next);
          if (tabs[next]) tabs[next].focus();
          e.preventDefault();
        }
      });

      /* ── Backdrop click ───────────────────────────── */
      if (backdrop) {
        backdrop.addEventListener('click', close);
      }

      /* ── Click outside ────────────────────────────── */
      document.addEventListener('click', function (e) {
        if (!isOpen()) return;
        if (!panel.contains(e.target) && !trigger.contains(e.target)) {
          close();
        }
      });
    });
  }

  /* ── Mobile drawer push-navigation ───────────────────────── */
  function initDrawerNav() {
    var panel = document.querySelector('[data-mh-drawer] .mh-drawer__panel');
    if (!panel || panel._mhNavBound) return;
    panel._mhNavBound = true;

    var history = ['main'];

    function getScreen(id) {
      return panel.querySelector('[data-mh-dscreen="' + id + '"]');
    }

    function showScreen(id, direction) {
      var entering = getScreen(id);
      var leaving  = panel.querySelector('[data-mh-dscreen].is-active');
      if (!entering) return;

      if (leaving && leaving !== entering) {
        leaving.classList.remove('is-active');
        leaving.classList.add(direction === 'back' ? 'is-right' : 'is-left');
        setTimeout(function () { leaving.classList.remove('is-left', 'is-right'); }, 320);
      }

      entering.classList.remove('is-left', 'is-right');
      entering.classList.add('is-active');
    }

    function push(id) {
      history.push(id);
      showScreen(id, 'forward');
    }

    function back() {
      if (history.length <= 1) return;
      history.pop();
      var prev = history[history.length - 1] || 'main';
      showScreen(prev, 'back');
    }

    panel.addEventListener('click', function (e) {
      var pushBtn = e.target.closest('[data-mh-dscreen-push]');
      if (pushBtn) { push(pushBtn.getAttribute('data-mh-dscreen-push')); return; }

      var backBtn = e.target.closest('[data-mh-dscreen-back]');
      if (backBtn) { back(); return; }
    });

    /* Reset history when drawer closes */
    var drawer = panel.closest('[data-mh-drawer]');
    if (drawer) {
      var obs = new MutationObserver(function (muts) {
        muts.forEach(function (m) {
          if (m.attributeName === 'class' && !drawer.classList.contains('is-open')) {
            setTimeout(function () {
              history = ['main'];
              panel.querySelectorAll('[data-mh-dscreen]').forEach(function (s) {
                s.classList.remove('is-active', 'is-left', 'is-right');
              });
              var main = getScreen('main');
              if (main) main.classList.add('is-active');
            }, 350);
          }
        });
      });
      obs.observe(drawer, { attributes: true });
    }
  }

  /* ── Collection grid accordion ───────────────────────────── */
  function initAccordion() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-mh-accordion-toggle]');
      if (!btn) return;
      var col1 = btn.closest('.mh-mega__col1');
      if (!col1) return;
      var grid = col1.querySelector('.mh-mega__grid');
      if (!grid) return;
      var expanded = grid.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      btn.querySelector('span').textContent = expanded ? 'View less' : 'View all collections';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initMegaMenu(); initDrawerNav(); initAccordion(); });
  } else {
    initMegaMenu();
    initDrawerNav();
    initAccordion();
  }

  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('[data-mh-mega-trigger]').forEach(function (t) {
      t._mhMegaBound = false;
    });
    var panel = document.querySelector('[data-mh-drawer] .mh-drawer__panel');
    if (panel) panel._mhNavBound = false;
    initMegaMenu();
    initDrawerNav();
  });

  document.addEventListener('shopify:block:load', function () { initMegaMenu(); initDrawerNav(); });
})();
